import { ServiceRequestConfig } from '~/services/createService';
import { k2 } from '~/services/serviceInstances';

import {
  ListTicketsApiArg,
  ListTicketsApiResponse,
  TicketState,
} from '../../types/k2/tickets';

type Request = {
  state?: TicketState | null;
  workflowId?: string | null;
  page?: {
    number?: number;
    size?: number;
  };
};

type ServerRequest = ListTicketsApiArg;
type ServerResponse = ListTicketsApiResponse;

export const listTicketsK2 = async (
  request: Request = {},
  options: ServiceRequestConfig = {},
) => {
  const params = mapParams(request);

  const serverResponse: ServerResponse = await k2.get('/tickets', {
    params,
    showErrorToast: true,
    ...options,
  });

  return mapResponse(serverResponse);
};

const mapParams = (request: Request): ServerRequest => {
  return {
    state: request.state ?? undefined,
    workflowId: request.workflowId ?? undefined,
    page: request.page,
  };
};

const mapResponse = (serverResponse: ServerResponse) => {
  return {
    data: serverResponse.data.map((ticket) => ({
      id: ticket.id,
      ...ticket.attributes,
    })),
    meta: serverResponse.meta,
  };
};
